var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9916 0.305241C21.8466 0.187948 21.6772 0.104641 21.4957 0.0614445C21.3143 0.0182476 21.1255 0.0162588 20.9432 0.0556247L11.2331 2.23977L1.52304 0.0306631C1.33785 -0.011161 1.14557 -0.0101873 0.960816 0.0335096C0.776064 0.0772065 0.603716 0.162475 0.456888 0.282826C0.310061 0.403176 0.192624 0.555437 0.113515 0.728019C0.034407 0.9006 -0.00428748 1.08895 0.000376772 1.27875V16.5054C-0.00667444 16.7939 0.0864756 17.0759 0.263971 17.3035C0.441466 17.531 0.692337 17.69 0.973881 17.7535L10.9585 20H11.5077L21.4924 17.7535C21.7739 17.69 22.0248 17.531 22.2023 17.3035C22.3798 17.0759 22.4729 16.7939 22.4659 16.5054V1.27875C22.465 1.09128 22.4219 0.906412 22.3398 0.737878C22.2577 0.569344 22.1387 0.421471 21.9916 0.305241ZM2.49654 2.83885L9.98504 4.52376V17.1918L2.49654 15.5069V2.83885ZM19.9697 15.5069L12.4812 17.1918V4.52376L19.9697 2.83885V15.5069Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c0565ed169288ff0d4587be9edfb2b22.svg";
export { ForwardRef as ReactComponent };